import { render } from "./AppSkeletonMenu.vue?vue&type=template&id=789ea26c&scoped=true"
import script from "./AppSkeletonMenu.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonMenu.vue?vue&type=script&lang=ts"

import "./AppSkeletonMenu.vue?vue&type=style&index=0&id=789ea26c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-789ea26c"

export default script